import React from 'react';
import { InputItem } from 'antd-mobile';
import Captialize from './Capitalize';
import './index.less';
import starBlack from '../../assets/image/titlebar_star_black.svg';
import starHalf from '../../assets/image/titlebar_star_half.svg';
import starFull from '../../assets/image/titlebar_star_full.svg';
import starBlackReadonly from '../../assets/image/titlebar_star_black_readonly.svg';
import starHalfReadonly from '../../assets/image/titlebar_star_half_readonly.svg';
import starFullReadonly from '../../assets/image/titlebar_star_full_readonly.svg';
const isIOS = /iphone|iPhone|ipad|ipod|ios/i.test(navigator.userAgent);

function getSpriteHref(mod){
    // svg-sprite-loader 可能返回 string / object / default
    let m = mod && mod.default ? mod.default : mod;
    if (!m) return '';
    if (typeof m === 'string') {
        return m.indexOf('#') >= 0 ? m : `#${m}`;
    }
    if (m.id) return `#${m.id}`;
    if (m.symbol && m.symbol.id) return `#${m.symbol.id}`;
    return '';
}

function getEventClientX(e){
    if (!e) return null;
    if (e.touches && e.touches[0]) return e.touches[0].clientX;
    if (typeof e.clientX === 'number') return e.clientX;
    return null;
}

class StarRate extends React.PureComponent{
    lastTouchTime = 0;

    getStarType = (i) => {
        let { value = 0, allowHalf } = this.props;
        if (value >= i) return 'full';
        if (allowHalf && value >= (i - 0.5)) return 'half';
        return 'black';
    }

    handleTouchStart = (e, starIndex) => {
        this.lastTouchTime = Date.now();
        this.onSelect(e, starIndex);
    }

    handleClick = (e, starIndex) => {
        // 移动端触摸后 300-500ms 内会触发合成 click，忽略它
        if (Date.now() - this.lastTouchTime < 500) {
            return;
        }
        // PC 端鼠标点击会走这里
        this.onSelect(e, starIndex);
    }

    onSelect = (e, starIndex)=>{
        let { disabled, allowHalf, onChange } = this.props;
        if (disabled) return;

        let nextValue = starIndex;
        if (allowHalf && e && e.currentTarget && e.currentTarget.getBoundingClientRect) {
            let rect = e.currentTarget.getBoundingClientRect();
            let clientX = getEventClientX(e);
            if (rect && rect.width && typeof clientX === 'number') {
                let ratio = (clientX - rect.left) / rect.width;
                nextValue = ratio <= 0.5 ? (starIndex - 0.5) : starIndex;
            }
        }

        // 支持清除：再次点击当前选中值时清空
        let current = this.props.value || 0;
        if (Math.abs(current - nextValue) < 0.001) {
            nextValue = 0;
        }
        onChange && onChange(nextValue);
    }

    render(){
        let { count = 5, disabled } = this.props;
        let stars = [];
        let iconMap = disabled ? {
            black: starBlackReadonly,
            half: starHalfReadonly,
            full: starFullReadonly,
        } : {
            black: starBlack,
            half: starHalf,
            full: starFull,
        };
        for (let i = 1; i <= count; i++) {
            let starType = this.getStarType(i);
            let iconCls = `titlebar_star_${starType}`;
            let href = getSpriteHref(iconMap[starType]);
            
            // 移动端：touchstart 并阻止默认行为，避免触发合成 click
            // PC端：只触发 click
            let eventProps = {
                onTouchStart: (e) => this.handleTouchStart(e, i),
                onClick: (e) => this.handleClick(e, i),
            };
            
            stars.push(
                <div key={i} className={`star-view fx-icon ${iconCls}`}>
                    <svg className="fx-icon-svg" aria-hidden="true">
                        <use xlinkHref={href} />
                    </svg>
                    <div
                        className="item-all"
                        value={i}
                        {...eventProps}
                    />
                </div>
            );
        }
        return (
            <div className={'metadata-control-rate' + (disabled ? ' rate-readonly' : '')} aria-label="rate">
                <div className="star-wraper">
                    {stars}
                </div>
            </div>
        );
    }
}

class NumberEl extends React.PureComponent{
    render(){
        let { length, decimal_places, captialize, form, extra, errorText,api_name, is_readonly, default_value, is_required, auto_adapt_places, biz_field_api_name, extra_config} = this.props;
        
        const { getFieldProps } = form;

        // 评星字段：biz_field_api_name=biz_field_rate
        if (biz_field_api_name === 'biz_field_rate') {
            let starscore = extra_config && extra_config.starscore;
            let isTenScore = Number(starscore) === 10;
            // 5分制和10分制最小值都是1（10分制允许0.5星，对应存储值1）
            let minRequiredValue = 1;

            let fieldProps = getFieldProps(api_name, {
                initialValue: default_value,
                validate: [{
                    trigger: 'onChange',
                    rules: [
                        {
                            validator: (rule, value, callback) => {
                                // 如果是必填项，检查是否至少选择了1分
                                if (is_required) {
                                    let numValue = parseFloat(value);
                                    // 检查值是否为空、0或小于最小值
                                    if (!value || isNaN(numValue) || numValue < minRequiredValue) {
                                        callback($st(`paas.smart.form.isrequired`));
                                        return;
                                    }
                                }
                                callback();
                            }
                        }
                    ],
                }],
            });

            let storedRawValue = form.getFieldValue(api_name);
            let storedNumValue = parseFloat(storedRawValue);
            let safeStoredNumValue = isNaN(storedNumValue) ? 0 : storedNumValue;

            // 5分制：存储值与展示值一致（0~5）
            // 10分制：存储值为0~10，展示值映射到0~5（除以2），并允许半星
            let count = 5;
            let displayValue = isTenScore ? safeStoredNumValue / 2 : safeStoredNumValue;
            if (isTenScore) {
                // 保证展示值落在半星刻度上
                displayValue = Math.round(displayValue * 2) / 2;
            }
            if (displayValue < 0) displayValue = 0;
            if (displayValue > count) displayValue = count;

            let handleRateChange = (v) => {
                let nextStored = isTenScore ? (v * 2) : v;
                if (fieldProps && typeof fieldProps.onChange === 'function') {
                    fieldProps.onChange(String(nextStored));
                    return;
                }
                // fallback
                if (form && typeof form.setFieldsValue === 'function') {
                    form.setFieldsValue({
                        [api_name]: String(nextStored)
                    });
                }
            };

            return (
                <div className={'number number--rate'}>
                    <StarRate
                        count={count}
                        allowHalf={isTenScore}
                        value={displayValue}
                        disabled={is_readonly}
                        onChange={handleRateChange}
                    />
                    {errorText && <div className='input-error'>{errorText}</div>}
                </div>
            );
        }
        
        let tempProps = {
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }],
            }],
            normalize: function(v, prev){
                v = v && v.trim()
                if(!v) return v;
                //校验是否是数字
                let _n = Number(v)
                if(isNaN(_n) || typeof _n  !== 'number') {
                    return prev;
                }

                let val = v.split('.')
                if(val.length > 2) return prev; //不合法，例如1.2.3

                let num = val[0] || 0, decimal = val[1];

                // 整数部分判断
                if ( (num + '').length > length ) return prev;
                
                //小数部分判断
                if (decimal && decimal.length > decimal_places) {
                    if (v === '.') {
                       return '0.';
                    }
                    return prev;
                }
                return v;
            }
        });
        let value = form.getFieldValue(api_name);
        let numberClass = isIOS ? 'iosColor' : ''
        return (
            <div className={'number' + (captialize ? ' money': '')}>
                <InputItem className={numberClass} {...tempProps}  {...fieldProps} /> 
                <span className="number__extra">{captialize ? '￥' : extra}</span>
                {captialize ? <Captialize className="number__capitalize" value={value} /> : null}
                {errorText && <div className='input-error'>{errorText}</div>}
            </div>
        )
    }
};

export default NumberEl;


// WEBPACK FOOTER //
// ./src/component/Number/Number.js